import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'
import { Comments } from '@one/types'

export class BackofficeCommentsApi extends ApiServiceWithSettings {
  getDiscussion(
    id: string
  ): AxiosPromise<Comments.Backoffice.Responses.DiscussionRestView> {
    return this.get(`/discussions/${id}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  addAttachment(
    id: string,
    attachments: Comments.Backoffice.Requests.AddAttachmentsRestCommand
  ): AxiosPromise<Comments.Backoffice.Responses.AttachmentsUploadUrlRestView> {
    return this.post(`/discussions/${id}/attachments`, attachments, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  addComment(
    id: string,
    comments: Comments.Backoffice.Requests.AddCommentsRestCommand
  ): AxiosPromise<{ commentIds: Array<string> }> {
    return this.post(`/discussions/${id}/comments`, comments, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  updateComment(
    id: string,
    commentId: string,
    comment: Comments.Backoffice.Requests.UpdateCommentRestCommand
  ): AxiosPromise<void> {
    return this.patch(`/discussions/${id}/comments/${commentId}`, comment, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  deleteComment(id: string, commentId: string): AxiosPromise<void> {
    return this.delete(`/discussions/${id}/comments/${commentId}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  unlinkAttachment(id: string, attachmentId: string): AxiosPromise<void> {
    return this.post(
      `/discussions/${id}/attachments/${attachmentId}/unlink`,
      {},
      {
        authentication: Authentication.REQUIRED,
        aud: Audience.BACKOFFICE
      }
    )
  }

  deleteAttachment(id: string, attachmentId: string): AxiosPromise<void> {
    return this.delete(`/discussions/${id}/attachments/${attachmentId}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  uploadAttachment(
    uploadUrl: string,
    formData: any,
    fileType: string
  ): AxiosPromise<void> {
    return this.put(uploadUrl, formData, {
      rawUrl: true,
      injectToken: false,
      injectTenant: false,
      headers: {
        'Content-Type': fileType
      }
    })
  }

  finishUpload(url: string): AxiosPromise<void> {
    return this.post(url, null, {
      rawUrl: true,
      injectToken: false,
      injectTenant: false
    })
  }

  generateAttachmentUrl(
    id: string,
    attachmentId: string
  ): AxiosPromise<Comments.Backoffice.Responses.AttachmentDownloadUrlRestView> {
    return this.get(
      `/discussions/${id}/attachments/${attachmentId}/download-url`,
      {
        authentication: Authentication.REQUIRED,
        aud: Audience.BACKOFFICE
      }
    )
  }
}
